import React from "react";
import { FaUsers, FaUserPlus, FaUserTie, FaDesktop, FaMobileAlt, FaAndroid } from "react-icons/fa";

const AddingBuyerPanel = () => {
  return (
    <div className=" mx-auto p-8 bg-white rounded-3xl shadow-xl border border-gray-200">
      
      {/* Panel Header */}
      <div className="flex items-center gap-4 mb-6">
        <FaUserPlus className="text-pink-600 text-4xl" />
        <h1 className="text-4xl font-extrabold text-gray-900">Adding Buyers</h1>
      </div>

      {/* Tags Section */}
      <div className="flex flex-wrap items-center gap-3 mb-8">
        <span className="bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-xs font-semibold">Seller</span>
        <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-semibold">Buyer</span>
        <div className="ml-auto flex gap-2">
          <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
            <FaDesktop /> Web
          </span>
    
          <span className="bg-green-50 text-green-700 px-3 py-1 rounded-full text-semibold text-xs flex items-center gap-1">
            <FaAndroid /> Android
          </span>
        </div>
      </div>

      {/* Intro */}
      <p className="text-gray-700 text-lg leading-relaxed mb-6">
        In Selzor, a <strong>‘Buyer’</strong> is an entity responsible for placing orders. There are two types:
      </p>

      {/* Buyer Types Section */}
      <div className="grid md:grid-cols-2 gap-8">
        {/* Buyers Managed by You */}
        <div className="p-6 bg-gray-50 rounded-2xl border border-gray-100 transition duration-300 hover:shadow-md">
          <h2 className="text-2xl font-bold mb-3 flex items-center gap-2 text-gray-800">
            <FaUserTie className="text-blue-500" /> Buyers Managed by You
          </h2>
          <p className="text-gray-700 mb-4">
            These are buyers you create manually. Navigate to the <strong>‘Buyers’</strong> section, select <em>‘Add a New Buyer’</em>, and fill in their details.
          </p>
          <div className="bg-yellow-100 border-l-4 border-yellow-400 text-yellow-800 p-4 rounded-md text-sm">
            These buyers do not have their own Selzor account, and you must enter orders on their behalf.
          </div>
        </div>

        {/* Self Managed Buyers */}
        <div className="p-6 bg-gray-50 rounded-2xl border border-gray-100 transition duration-300 hover:shadow-md">
          <h2 className="text-2xl font-bold mb-3 flex items-center gap-2 text-gray-800">
            <FaUsers className="text-blue-400" /> Self Managed Buyers
          </h2>
          <p className="text-gray-700 leading-relaxed">
            These buyers register on Selzor as a <strong>‘Buyer’</strong>. They connect with you by entering your App Code, and once approved, they can place orders directly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddingBuyerPanel;